<script>
  import { router } from '@inertiajs/svelte'

  let { logs = [], pagination = {}, filters = {}, admins = [], action_types = [], stats = {} } = $props()

  // svelte-ignore state_referenced_locally
  const initialActionFilter = filters.action_filter || ''
  // svelte-ignore state_referenced_locally
  const initialAdminFilter = filters.admin_id || ''
  let actionFilter = $state(initialActionFilter)
  let adminFilter = $state(initialAdminFilter)

  function applyFilters() {
    const params = {}
    if (actionFilter) params.action_filter = actionFilter
    if (adminFilter) params.admin_id = adminFilter
    router.get('/admin/audit_logs', params, { preserveState: true })
  }

  function goToPage(page) {
    router.get('/admin/audit_logs', { ...filters, page }, { preserveState: true })
  }

  function getActionColor(action) {
    if (action.includes('ban') || action.includes('reject') || action.includes('delete')) return 'text-error'
    if (action.includes('blind')) return 'text-orange-600 dark:text-orange-400'
    if (action.includes('approve') || action.includes('unban') || action.includes('verify')) return 'text-success'
    if (action.includes('warning')) return 'text-warning-dark dark:text-warning'
    return 'text-gray-700 dark:text-dark-text-medium'
  }

  function getActionLabel(action) {
    const labels = {
      'post.approve': '게시글 승인',
      'post.reject': '게시글 반려',
      'post.flag': '게시글 플래그',
      'post.blind': '게시글 블라인드',
      'post.unblind': '게시글 블라인드 해제',
      'post.batch_approve': '게시글 일괄 승인',
      'post.batch_reject': '게시글 일괄 반려',
      'post.batch_blind': '게시글 일괄 블라인드',
      'post.batch_delete': '게시글 일괄 삭제',
      'user.update': '사용자 수정',
      'user.ban': '사용자 정지',
      'user.unban': '사용자 정지 해제',
      'user.verify': '사용자 인증',
      'report.approve': '신고 승인',
      'report.reject': '신고 기각',
      'report.warning': '경고 발송',
      'report.dismiss': '신고 무시',
      'comment.approve': '댓글 승인',
      'comment.reject': '댓글 삭제',
      'comment.blind': '댓글 블라인드',
      'comment.unblind': '댓글 블라인드 해제',
      'comment.restore': '댓글 복구',
      'comment.permanent_delete': '댓글 영구삭제',
      'comment.batch_approve': '댓글 일괄 승인',
      'comment.batch_reject': '댓글 일괄 반려',
      'comment.batch_delete': '댓글 일괄 삭제',
      'org.create': '기관 등록',
      'org.update': '기관 수정',
      'org.delete': '기관 삭제',
      'org.toggle_verification': '기관 인증 토글',
      'org.toggle_login_access': '기관 로그인 접근 토글'
    }
    return labels[action] || action
  }

  function getTargetLink(log) {
    if (!log.target_type || !log.target_id) return null
    const paths = {
      Post: `/admin/posts/${log.target_id}`,
      User: `/admin/users/${log.target_id}`,
      Report: `/admin/reports/${log.target_id}`,
      Organization: `/admin/organizations/${log.target_id}`,
      Comment: `/admin/comments/${log.target_id}`
    }
    return paths[log.target_type] || null
  }
</script>

<div class="space-y-6">
  <!-- Header -->
  <header class="bg-surface border-b border-default">
    <div class="container mx-auto px-4 lg:px-6 py-4">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-4">
          <h1 class="text-h2 text-content">🛡️ 관리자</h1>
          <span class="badge badge-error">ADMIN</span>
        </div>
        <a href="/" class="text-body2 text-content-tertiary hover:text-primary transition-colors">← 사이트로 돌아가기</a>
      </div>
    </div>
  </header>

  <!-- Navigation -->
  <nav class="bg-white/70 dark:bg-dark-secondary/70 backdrop-blur border-b border-default">
    <div class="container mx-auto px-4 lg:px-6">
      <div class="flex items-center gap-1">
        <a href="/admin" class="px-4 py-3 text-label text-content-tertiary hover:text-gray-900 dark:hover:text-dark-text-high transition-colors">대시보드</a>
        <a href="/admin/users" class="px-4 py-3 text-label text-content-tertiary hover:text-gray-900 dark:hover:text-dark-text-high transition-colors">사용자</a>
        <a href="/admin/posts" class="px-4 py-3 text-label text-content-tertiary hover:text-gray-900 dark:hover:text-dark-text-high transition-colors">게시글</a>
        <a href="/admin/comments" class="px-4 py-3 text-label text-content-tertiary hover:text-gray-900 dark:hover:text-dark-text-high transition-colors">댓글</a>
        <a href="/admin/reports" class="px-4 py-3 text-label text-content-tertiary hover:text-gray-900 dark:hover:text-dark-text-high transition-colors">신고</a>
        <a href="/admin/organizations" class="px-4 py-3 text-label text-content-tertiary hover:text-gray-900 dark:hover:text-dark-text-high transition-colors">기관</a>
        <a href="/admin/audit_logs" class="px-4 py-3 text-label text-primary border-b-2 border-primary font-semibold">감사 로그</a>
      </div>
    </div>
  </nav>

  <main class="container mx-auto px-4 lg:px-6 py-8">
    <div class="flex items-center justify-between mb-6">
      <h2 class="text-h1 text-content">감사 로그</h2>
      <div class="flex items-center gap-4 text-body2">
        <span class="px-3 py-1 bg-surface-tertiary text-content-secondary rounded-lg">
          전체 {stats.total || 0}건
        </span>
        <span class="px-3 py-1 bg-primary-50 dark:bg-primary/10 text-primary rounded-lg font-medium">
          오늘 {stats.today || 0}건
        </span>
      </div>
    </div>

    <!-- Filters -->
    <div class="card card-bordered p-4 mb-6 shadow-md">
      <div class="flex flex-wrap items-center gap-4">
        <select bind:value={actionFilter} class="select">
          <option value="">모든 액션</option>
          {#each action_types as action}
            <option value={action}>{getActionLabel(action)}</option>
          {/each}
        </select>

        <select bind:value={adminFilter} class="select">
          <option value="">모든 관리자</option>
          {#each admins as admin}
            <option value={admin.id}>{admin.name}</option>
          {/each}
        </select>

        <button onclick={applyFilters} class="btn btn-primary btn-md">검색</button>
      </div>
    </div>

    <!-- Logs Table -->
    <div class="card card-bordered overflow-hidden shadow-md">
      <table class="w-full">
        <thead class="bg-surface-tertiary">
          <tr>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">시간</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">관리자</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">액션</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">대상</th>
            <th class="px-6 py-3 text-left text-caption font-semibold text-content-tertiary uppercase">IP</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-dark-border">
          {#each logs as log}
            <tr class="hover:bg-gray-50 dark:hover:bg-dark-tertiary transition-colors">
              <td class="px-6 py-4 text-body2 text-content-tertiary whitespace-nowrap">
                {new Date(log.created_at).toLocaleString('ko-KR', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })}
              </td>
              <td class="px-6 py-4">
                <div class="text-body2 font-medium text-content">{log.admin?.name}</div>
                <div class="text-caption text-content-tertiary">{log.admin?.email}</div>
              </td>
              <td class="px-6 py-4">
                <span class={`text-body2 font-semibold ${getActionColor(log.action)}`}>
                  {getActionLabel(log.action)}
                </span>
                {#if log.metadata?.note}
                  <div class="text-caption text-content-tertiary mt-0.5 truncate max-w-[200px]">
                    "{log.metadata.note}"
                  </div>
                {/if}
                {#if log.metadata?.count}
                  <div class="text-caption text-content-tertiary mt-0.5">
                    ({log.metadata.count}건)
                  </div>
                {/if}
              </td>
              <td class="px-6 py-4">
                {#if log.target_label}
                  {@const link = getTargetLink(log)}
                  <div class="text-caption text-content-tertiary">{log.target_type}</div>
                  {#if link}
                    <a href={link} class="text-body2 text-primary hover:text-primary-dark truncate max-w-[200px] block">
                      {log.target_label}
                    </a>
                  {:else}
                    <span class="text-body2 text-gray-700 dark:text-dark-text-medium truncate max-w-[200px] block">{log.target_label}</span>
                  {/if}
                {:else}
                  <span class="text-caption text-gray-400">-</span>
                {/if}
              </td>
              <td class="px-6 py-4 text-caption text-content-tertiary font-mono">
                {log.ip_address || '-'}
              </td>
            </tr>
          {/each}
        </tbody>
      </table>

      {#if logs.length === 0}
        <div class="text-center py-12 text-content-tertiary">
          감사 로그가 없습니다
        </div>
      {/if}
    </div>

    <!-- Pagination -->
    {#if pagination.total_pages > 1}
      <div class="flex items-center justify-center gap-2 mt-6">
        <button
          onclick={() => goToPage(pagination.current_page - 1)}
          disabled={pagination.current_page === 1}
          class="btn btn-secondary btn-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >이전</button>
        <span class="px-4 py-2 text-body2 text-content-tertiary">
          {pagination.current_page} / {pagination.total_pages}
        </span>
        <button
          onclick={() => goToPage(pagination.current_page + 1)}
          disabled={pagination.current_page === pagination.total_pages}
          class="btn btn-secondary btn-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >다음</button>
      </div>
    {/if}
  </main>
</div>
